export default "__VITE_ASSET__BRE3iZdS__"